module.exports = __webpack_public_path__ + "static/media/12.55feef4d.jpg";